import { Component, Vue } from "vue-property-decorator";
import {clickOutside} from '@/directives/clickOutside.ts';


@Component({

  directives:  {

    outside: clickOutside

  }
})

export default class Modal extends Vue {
  
  closeModal(){

    setTimeout(() => {

      this.$emit('closeModal');

    }, 300)
  }
}
